module.exports = __webpack_public_path__ + "static/media/game-foreword.da350bdf.png";